var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.7,
    cx: 11.136,
    cy: 10.864,
    r: 10.864,
    fill: "#222"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.186 14.815 7.9-7.9M15.087 14.815l-7.901-7.9",
    stroke: "#fff",
    strokeWidth: 1.82,
    strokeLinecap: "round"
  })));
};
export default SvgDelete;